import { Reveal, SectionLabel } from "./shared";

const stats = [
  { value: "3", line: "years working alongside Snehalaya, Ahmednagar", id: "years-snehalaya" },
  { value: "100+", line: "students reached through our programs", id: "students-reached" },
  {
    value: "18+",
    line: "care leavers placed in jobs across hospitality, F&B, and coaching",
    id: "care-leavers-placed",
  },
  { value: "36", line: "young women trained through our bakery program", id: "women-bakery-trained" },
];

export const TrackRecord = () => (
  <section className="py-24 md:py-36" data-testid="track-record-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="max-w-2xl">
        <SectionLabel testId="track-record-label">Track Record</SectionLabel>
        <h2
          className="font-heading text-3xl sm:text-4xl md:text-[2.75rem] font-semibold tracking-tight text-[#1F2043] leading-[1.15]"
          data-testid="track-record-headline"
        >
          Three years in the field. Real numbers.
        </h2>
      </Reveal>
      <div className="mt-14 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {stats.map((stat, i) => (
          <Reveal key={stat.id} delay={i * 0.08} testId={`stat-block-${stat.id}`}>
            <p className="font-heading text-5xl md:text-6xl font-bold text-[#00867A] tracking-tight leading-none">
              {stat.value}
            </p>
            <p className="font-body mt-4 text-sm md:text-base font-light leading-relaxed text-[#3C3C3B]">
              {stat.line}
            </p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.15}>
        <p className="font-body mt-16 md:mt-20 text-sm font-light leading-relaxed text-[#3C3C3B]/70 max-w-4xl" data-testid="partner-names-line">
          We&rsquo;ve worked with Snehalaya, Pratham, Code to Enhance Learning, Saathiya Skilling
          Academy, Navgurukul, Don Bosco, Salaam Bombay Foundation &mdash; and alongside DWCD,
          MSPAA, and UNICEF within Maharashtra&rsquo;s aftercare ecosystem.
        </p>
      </Reveal>
    </div>
  </section>
);
